import "./Header.css";

function Header() {
    return (
        <header className="header">
            <ul>
                <li>
                    <a
                        className="hover-underline-animation"
                        href="https://cryptonitemit.in"
                        target="_blank"
                        rel="noreferrer"
                    >
                        About us
                    </a>
                </li>
                {/* <li><a className="hover-underline-animation" href="#/teams" target="_blank" rel="noreferrer">Teams</a></li> */}
                {/* <li><a className="hover-underline-animation" href="#/scoreboard" target="_blank" rel="noreferrer">Scoreboard</a></li> */}
                {/* <li><a className="hover-underline-animation" href="#/notifications" target="_blank" rel="noreferrer">Notifications</a></li> */}
                {/* <li><a className="hover-underline-animation" href="#/challenges" target="_blank" rel="noreferrer">Challenges</a></li> */}
                {/* <li><a className="hover-underline-animation" href="#/rules" target="_blank" rel="noreferrer">Rules</a></li> */}
                {/* <li><a className="hover-underline-animation" href="#/faq" target="_blank" rel="noreferrer">FAQ</a></li> */}
                {/* <li><a className="hover-underline-animation" href="#/register" target="_blank" rel="noreferrer">Register</a></li> */}
                {/* <li><a className="hover-underline-animation" href="#/login" target="_blank" rel="noreferrer">Login</a></li> */}
            </ul>
        </header>
    );
}

export default Header;
